import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const ConfirmationDialog = (props) => {
    const { dialogContent, onCancel, onOk, open, dialogTitle, hideCancel = false } = props;
    return (
        <Dialog open={open} maxWidth="xs" aria-labelledby="confirmation-dialog-title">
            <DialogTitle id="confirmation-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>{dialogContent}</DialogContent>
            <DialogActions>
                {!hideCancel && (
                    <Button onClick={onCancel} color="primary">
                        Cancel
                    </Button>
                )}
                <Button onClick={onOk} color="primary">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
